
import { GetSlimRequest } from "@xng/xng-backend";
import { API_SESSIONS_BACKEND } from "../../../../api/api";
import useApiMutateData, { MSBMutationOptionsType } from "../../../../api/hooks/use_api_mutate_data";

type Data = Awaited<ReturnType<typeof API_SESSIONS_BACKEND.getSlim>>;
type Body = GetSlimRequest;

type ParamObject = {
  options?: Omit<MSBMutationOptionsType<Data, Body>, "mutationFn" | "mutationKey">;
};

const useApiQueryUnpostedSessionsData = (paramObject?: ParamObject) => {
  return useApiMutateData<Data, Body>({
    mutationFn: async (body: Body) =>
      await API_SESSIONS_BACKEND.getSlim(body),
    mutationKey: ["v1SessionsSlimGet"],
    ...paramObject?.options,
  });
};

export default useApiQueryUnpostedSessionsData;
